const config = {
    tileSource: 'https://bb209a101d41d7029d4e-93330d88a2f4bfa442606fd6e2955d9a.ssl.cf5.rackcdn.com/garden-map-2018/v1/{z}/{x}/{y}.png',
    showHelp: !!parseInt(process.env.VUE_APP_SHOW_HELP),
    showMenu: !!parseInt(process.env.VUE_APP_SHOW_MENU)
}

if (process.env.NODE_ENV == 'production') {
    // Where to get the locations
    config.exhibit_locations_url = process.env.VUE_APP_CMS_ROOT + '/locations'

    // Where to get the CMSed exhibit data (All Media info etc.)
    config.exhibit_data_url = process.env.VUE_APP_CMS_ROOT + '/exhibits'

    // Where to get the CMSed exhibit data (All Media info etc.)
    config.items_url = process.env.VUE_APP_CMS_ROOT + '/items/'
} else {
    // Where to get the locations
    config.exhibit_locations_url = process.env.VUE_APP_CMS_ROOT + '/locations'

    // Where to get the CMSed exhibit data (All Media info etc.)
    config.exhibit_data_url = process.env.VUE_APP_CMS_ROOT + '/exhibits'

    // Where to get the CMSed exhibit data (All Media info etc.)
    config.items_url = process.env.VUE_APP_CMS_ROOT + '/items/'
}

export default config